module.exports = __webpack_public_path__ + "cm.bee8c924f3009e40aed2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cm.svg
// module chunks = styles